import { render } from "./ExcludeDay.vue?vue&type=template&id=ae510d64"
import script from "./ExcludeDay.vue?vue&type=script&lang=js"
export * from "./ExcludeDay.vue?vue&type=script&lang=js"

import "./ExcludeDay.vue?vue&type=style&index=0&id=ae510d64&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__